import EMLLight from "../assets/dsls-logos/eml_L.png";
import EMLDark from "../assets/dsls-logos/eml_D.png";
import { getDocumentation } from "./eml/documentation.js";


/**
 * Retrieves the constants for the Generos domain specific language.
 * @returns {Promise<Object>} The constants object.
 */
export const getEMLConstants = async () => {
	const constants = {
		enabled: true,
		_id: "eml",
		name: "EML",
		short: "eml",
		description: "EML is a Domain-Specific Language (DSL) designed for modeling Cyber-Physical Systems (CPS)",
		logoUrl: EMLLight,
		logoUrlDark: EMLDark,
		insertableEntities: {},
		shortDescription: "",
		documentation: getDocumentation(),
		subtypes: [],
		hasValidation: true,
		type: "Textual",
		canTransformTo: ["json"],
		mustImport: [],
		canImport: [],
		supportsGeneration: false,
		supportsDeployment: false,
		deploymentStoppable: false,
		generationLanguage: "",
		generations: [],
		generationsOutputMap: {
			Default: "string",
		},
		keywords: ["Broker::AMQP", "Broker::MQTT", "Broker::Redis", "RESTEndpoint", "Entity", "Entity::Sensor", "Entity::Actuator", "Entity::Hybrid", "Entity::Robot", "Entity::Other"],
		llmSupport: false,
		tags: ["Cyber-Physical Systems", "Textual"],
		initiallyCollapsed: false,
		experimental: true,
	};
	return constants;
};
